// Above-ground commercial floor factor — rules/FACTOR_TABLES_MVP.md §6.

import type { CommercialFloor } from "../types/enums.js";

export const COMMERCIAL_FLOOR_TABLE: Readonly<Record<CommercialFloor, number>> = {
  首层商业: 1,
  第二层商业: 0.6,
  第三层商业: 0.5,
  第四层及以上商业: 0.4,
};
